import { createFileRoute, notFound } from '@tanstack/react-router';
import { environment } from '@/env/environment';
import { SignUpPage } from '@/features/auth/pages/SignUpPage';

export const Route = createFileRoute('/sign-up')({
  beforeLoad: () => {
    if (!environment.features.openSignUp) throw notFound();
  },
  component: SignUpPage,
});
